<template>
  <router-view />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters('me', {
      language: 'language',
    }),
  },
  watch: {
    language: {
      immediate: true,
      handler (value) {
        this.$i18n.locale = value
        this.$vuetify.lang.current = value
      },
    },
  },
  mounted () {
    this.$store.dispatch('me/init')
  },
}
</script>
